 <template>

   <div class="icon_container">
      <i class="fas fa-bell cursor-pointer text-white hover:text-gray-300"  @click="reveal"></i>
      <div v-if="reveal_list" class="list_container">
         <div class="list_title">Notificações</div>
         <div class="list_entries">
            <div class="list_entry" v-for="(message, index) in data" :key="index">
                <div class="list_text" v-for="(value, key) in message" :key="key">
                    {{ value }}
                </div>
            </div>
         </div>
         
      </div>
   </div>
   
 </template>

<script>
   export default {
      name:'   AppNotification',
      props: {
         data:{
            type: Array,
            default: () =>[
               {titulo: "trabalho para fazer"},
               {titulo: "Encomendar mais Extintores"},
               {titulo: "Entregar Viatura"},
               {titulo: "Reabastecer Extintor"},
               {titulo: "Reabastecer Extintor"},
               {titulo: "Reabastecer Extintor"},
               {titulo: "Reabastecer Extintor"},
               {titulo: "Reabastecer Extintor"},
               {titulo: "Reabastecer Extintor"},
            ]

         },
         visibility:{
            type: Boolean,
            default: () => false
         }
      },
      methods:{
         reveal(){
            this.reveal_list=!this.reveal_list;
         }
      },
      data(){
         return{
            reveal_list:false,

         }
      }
   }
</script>


<style>
   .icon_container {
         position: relative;
         display: inline-block;
      }

    i {
        justify-self: center;
        align-self: center;
        position: relative;
        padding: 0.5rem;
       
    }
   .list_container {
        position: absolute;
        top: calc(100% + 0.5rem);
        left: calc(100% - 6.2rem);
        background-color: #4D4D6C;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0.4rem;
        padding: 1rem 1rem;
        z-index: 999;
        width: fit-content;
        height: fit-content;
       
    }
    .list_title{
         color: #ff9b05;
         font-family: 'Poppins', sans-serif;
         font-size: 10px;
         border-bottom: 1px solid #ff9b05;
         width:100%;
         white-space: nowrap;
    }
    .list_entries{
         width: fit-content;
         height:fit-content;
         display: flex;
         flex-direction: column;
         gap: 0.4rem;
         overflow-y: auto;
         max-height: 9.6rem;
         scrollbar-color: #ff9b05 transparent;
         scrollbar-width: thin;
    }
    .list_entry {
         /* border-bottom: 1px solid white; */
         border-radius: 8px;
         background-color: #2e2e48;
         padding: 0.3rem;
         width: 100%;
        
    }

    .list_text {
        font-family: 'Poppins', sans-serif;
        font-size: 10px;
        color: #ffffff;
        white-space: nowrap;
    }
</style>